import React from 'react';
import _ from 'lodash';

import { useTriageReasonSelectFieldQuery } from 'generated/graphql';



export interface ITriageReason {
  id: string;
  reasonText: string;
}

export interface IData {
  objects: ITriageReason[];
}

export function useQuery(storeId: string) {
  const queryTuple = useTriageReasonSelectFieldQuery({
    variables: {
      storeId
    }
  });

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(queryTuple.data?.store?.triageReasons ?? [], (node): ITriageReason => ({
        id: node.id,
        reasonText: node.reasonText
      }))
    };

    return {
      loading: queryTuple.loading,
      data,
      refetch: async () => {
        queryTuple.refetch({});
      }
    };
  }, [queryTuple]);

  return wrappedTuple;
}
